import React from 'react'
import { NavLink } from "react-router-dom";

const Navbar = ({userName, SignOut}) => {
  console.log("Navbar", userName)
  return (
    <nav className="navbar">
        <div className="navbar__logo">
          {userName || 'Ryan'}'s Blog
        </div>
        <ul className="navbar__list">
          <li className="navbar__list--item">
            <SignOut />
          </li>
          <li className="navbar__list--item">
            <NavLink 
              to="/" 
              exact activeClassName="navbar__list--item-link active"
              className="navbar__list--item-link">
              Home
            </NavLink>
          </li>
          <li className="navbar__list--item">
            <NavLink
              to="./profile" 
              activeClassName="navbar__list--item-link active"
              className="navbar__list--item-link">
              Profile
            </NavLink>
          </li>
        </ul>
      </nav>
  )
}

export default Navbar
